import axios, { getData } from "../../../axios";
import * as tPromise from "io-ts-promise";
import { createAction, createSlice } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import {
  DriverTimeReserved,
  DriverTimeReservedUpdatedEvent,
  driversTimeReservedT,
} from "dora-contracts";

const prefix = "data/driver-time-reserved";

type State = {
  byDriverId: Record<string, DriverTimeReserved>;
  // Only tracks timestamps of applied websocket updates, so a stale/out-of-order
  // one for a driver can be told apart from a REST fetch (always applied as-is).
  lastEventTimestamp: Record<string, string>;
};

const initialState: State = {
  byDriverId: {},
  lastEventTimestamp: {},
};

export const loadTimeReservedForDrivers = createErrorReportingAsyncThunk(
  `${prefix}/load-for-drivers`,
  async (driverIds: string[]) => {
    if (!driverIds.length) return [];
    return axios
      .post("/api/driver-time-reserved/get-for-drivers", { driverIds })
      .then(getData)
      .then(tPromise.decode(driversTimeReservedT));
  }
);

// Dispatched when a "driver-time-reserved.updated" websocket message is received.
export const timeReservedUpdated = createAction<DriverTimeReservedUpdatedEvent>(
  `${prefix}/updated`
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadTimeReservedForDrivers.fulfilled, (state, action) => {
        for (const entry of action.payload) {
          state.byDriverId[entry.driverId] = entry;
        }
      })
      .addCase(timeReservedUpdated, (state, action) => {
        const { timestamp, ...entry } = action.payload;
        const lastTimestamp = state.lastEventTimestamp[entry.driverId];
        if (lastTimestamp && lastTimestamp >= timestamp) {
          return;
        }
        state.lastEventTimestamp[entry.driverId] = timestamp;
        state.byDriverId[entry.driverId] = entry;
      });
  },
});

export default slice.reducer;
